import React, { useState } from 'react';
import DashboardSidebar from '../dashboard/DashboardSidebar';
import { Outlet } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';

const DashboardLayout = () => {
  const [isActive, setIsActive] = useState(false);

  const handleSidebar = () => {
    setIsActive(!isActive);
  };

  return (
    <div className="dashboard-layout flex h-screen overflow-y-hidden">
      <DashboardSidebar isActive={isActive} handleSidebar={handleSidebar} />

      <div
        className={`relative dashboard-content-wrapper bg-dashboard-bg ${isActive ? 'active' : ''}`}
      >
        <span onClick={handleSidebar}>
          <MenuOutlined className="hamburger-icon cursor-pointer xl:hidden" />
        </span>
        {/* <div className="container mx-auto"> */}
        <Outlet />
        {/* </div> */}
      </div>
    </div>
  );
};

export default DashboardLayout;
